import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type BriefcaseProps = {
    className?: string;
};

const Briefcase: FunctionComponent<BriefcaseProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'briefcase'}
            viewBox="0 0 250 250"
        >
            <path d="M249.8 73c-.9-6.2-6.3-11-12.7-11h-56.9V38.9c0-7.1-5.8-12.9-12.9-12.9H84.7c-7.1 0-12.9 5.8-12.9 12.9v.9c-.1.7-.2 1.4-.2 2.1V62H12.9C6.4 62 1.1 66.8.2 73H0v138.2c0 7.1 5.8 12.9 12.9 12.9h224.2c7.1 0 12.9-5.8 12.9-12.9V73h-.2zm-164-33h80.4v22H85.8V40zM12.9 71h224.2c2.1 0 3.9 1.7 3.9 3.9v2.8c0 36.6-29.3 66.4-65.3 66.4H137V139c0-1.6-1.3-2.9-2.9-2.9h-18.2c-1.6 0-2.9 1.3-2.9 2.9v5.1H74.3C38.3 144 9 114.2 9 77.6v-2.8c0-2.1 1.7-3.8 3.9-3.8zM241 211.1c0 2.1-1.7 3.9-3.9 3.9H12.9c-2.1 0-3.9-1.7-3.9-3.9v-97.5C21.6 137.1 46.1 153 74.3 153H113v6.1c0 1.6 1.3 2.9 2.9 2.9h18.2c1.6 0 2.9-1.3 2.9-2.9V153h38.7c28.2 0 52.7-15.9 65.3-39.4v97.5z" />
        </svg>
    );
};

export default Briefcase;
